import styles from "./GenresFilter.module.css"
import { useGenres } from "@/apiUtilities/queries/useGenres"
import Pill from "@/components/UI/Buttons/Pill/Pill"
import { Genre } from "@/interfaces/genres";
import { useLocale, useTranslations } from "next-intl"
import { useSearchParams } from "next/navigation";
import { useEffect, useState } from "react"

function parseGenreValues(str: string): string[] {
	if (!str) return [];
	const matches = str.match(/&genre=([^&]+)/g);
	if (!matches) return [];
	return matches.map(m => m.replace("&genre=", ""));
}

export default function GenresFilter({ update, resetSignal, initialData }: {
	update: (name: string, value: string) => void,
	resetSignal: number,
	initialData: string 
}) {
	const locale = useLocale()
	const params = useSearchParams();
	const initialGenre = params.get('genre');
	const { data: genresData, isSuccess } = useGenres(locale)
	const [genres, setGenres] = useState<(Genre & { checked: boolean })[]>([])
	const t = useTranslations('Catalogue')
	function toggleGenre(id:string) {
		setGenres(prev => prev.map(genre => 
			genre.id === id ? {...genre, checked: !genre.checked} : genre
		))
	}

	function isChecked(id: string) {
		return genres.find(genre => genre.id === id)?.checked ?? false
	}

	useEffect(() => {
		const genreString = genres
			.filter(genre => genre.checked)
			.map(genre => "&genre=" + genre.id)
			.join("")
		update("genres", genreString)
	}, [genres])

	useEffect(() => {
		if(isSuccess) {
			setGenres(genresData.map(genre => { return {...genre, checked: false} }))
		}
	}, [resetSignal])

	useEffect(() => {
		if(isSuccess) {
			const initialValues = parseGenreValues(initialData);
			setGenres(genresData.map((genre: Genre) => ({
				...genre,
				checked: initialValues.includes(genre.id) || genre.id === initialGenre
			})));
		}
	}, [isSuccess])

	return (
		<div data-testid="GenresFilter">
			<h4 className={`bodyTextMedium ${styles.title}`} data-testid="GenresFilter_title">{t('categoriesTitle')}</h4>
			<div className={styles.filters}>
				{genres.map(genre => <Pill key={genre.id} checked={isChecked(genre.id)} onClick={() => toggleGenre(genre.id)}>{genre.name}</Pill>)}
			</div>
		</div>
	)
}